<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100"
                    fixed-header height="calc(100vh - 300px)">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.ID }}</td>
                            <td>{{ item.Username }}</td>
                            <td>{{ item.Email }}</td>
                            <td>{{ item.FullName }}</td>
                            <td>{{ item.RoleID | display_value(role_list) }}</td>
                            <td v-bind:style="{ 'color': item.is_active == 1 ? '#0059b3' : '#e63900'}">{{ item.is_active == 1 ? 'Đã kích hoạt' : 'Đang bị khóa' }}</td>
                            <td class="text-center">
                                <table-action-buttons :actions="getItemActions(item)"></table-action-buttons>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
import md5 from "md5";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        let dataType = configs.DATA_TYPE;
        let roles = configs.ROLES;
        return {
            headers: [{
                    text: this.$t('table_headers.id'),
                    value: "ID",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: this.$t('table_headers.username'),
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: this.$t('table_headers.email'),
                    value: "Email",
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: this.$t('table_headers.full_name'),
                    value: "FullName",
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: this.$t('table_headers.role'),
                    value: "RoleID",
                    filterable: true,
                    dataType: dataType["Enum"],
                    values: roles
                },
                {
                    text: this.$t('table_headers.status'),
                    value: "is_active",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: this.$t('table_headers.action'),
                    value: "",
                    width: "140px",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            role_list: roles,
            viewName: "staff_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: mapState({
        items: state => state.staff.all.data,
        total_rows: state => state.staff.all.total,
        loading: state => state.staff.loading,
        currentStaff: state => state.staff.selected
    }),
    methods: {
        getItemActions(item) {
            return [
                { label: this.$t('actions.edit'), variant: 'primary', onClick: () => this.gotoDetail(item.ID) },
                { label: this.$t('actions.reset_password'), variant: 'warning', onClick: () => this.resetPassword(item.ID) },
                { label: this.$t('actions.delete'), variant: 'danger-outline', onClick: () => this.deleteItem(item.ID) }
            ];
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("staff/getList", param);
        },
        gotoDetail: function (id) {
            this.$router.push({
                name: "StaffDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết nhân viên (#${id})`
                }
            });
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        resetPassword: function(id) {
            this.$store.dispatch("staff/setDetail", {
                'data': {Password: md5('Apl@68')},
                'id': id,
                'notify': 'Đã reset mật khẩu về mặc định (Apl@68)'
            });
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData(username = '') {
            this.$router.push({
                name: "StaffDetail",
                params: {
                Pid: 'tao-moi',
                title: `Tạo mới nhân viên`
                }
            });
        },
        storeDisplay(value) {
            const store = _.find(this.stores, {'ID': value});
            return store ? store.Name : '';
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("staff/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
